import { render, staticRenderFns } from "./FontColorSetter.vue?vue&type=template&id=12885905&scoped=true&"
import script from "./FontColorSetter.vue?vue&type=script&lang=js&"
export * from "./FontColorSetter.vue?vue&type=script&lang=js&"
import style0 from "./FontColorSetter.vue?vue&type=style&index=0&id=12885905&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12885905",
  null
  
)

component.options.__file = "FontColorSetter.vue"
export default component.exports